<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="login-icon">
          <i class="el-icon-s-custom"></i>
        </div>
        <h1>365n 全平台管理中心</h1>
        <p>总管理员专用入口</p>
      </div>
      <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入账号" prefix-icon="el-icon-user">
            <template slot="prepend"><i class="el-icon-user"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password @keyup.enter.native="handleLogin">
            <template slot="prepend"><i class="el-icon-lock"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.remember">保持登录状态</el-checkbox>
          <span class="help-link">遇到问题?</span>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" class="login-btn" :loading="loading" @click="handleLogin">立即登录</el-button>
        </el-form-item>
      </el-form>
      <div class="login-footer">
        <span>© 2026 365n 全平台管理系统 版权所有</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', {
            username: this.form.username,
            password: this.form.password
          }).then(() => {
            // 登录成功后拉取用户信息和权限
            return this.$store.dispatch('fetchUserInfo')
          }).then(() => {
            this.$router.push('/dashboard')
            this.$message.success('登录成功')
          }).catch(err => {
            this.$message.error(err.message || '登录失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
}

.login-card {
  width: 420px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-header {
  padding: 40px 32px 0;
  text-align: center;
}

.login-icon {
  width: 64px;
  height: 64px;
  background: #E4393C;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(228, 57, 60, 0.4);
}

.login-header h1 {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 8px;
}

.login-header p {
  font-size: 13px;
  color: #909399;
  margin: 0 0 32px;
}

.login-form {
  padding: 0 32px;
}

.help-link {
  color: #E4393C;
  font-size: 13px;
  cursor: pointer;
  float: right;
}

.login-btn {
  width: 100%;
  background: #E4393C;
  border-color: #E4393C;
}

.login-btn:hover {
  background: #c91b1d;
  border-color: #c91b1d;
}

.login-footer {
  padding: 16px 32px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: 12px;
  color: #c0c4cc;
}
</style>
